<template>
  <div class="view--trial-coupon">
    <loader v-if="loader"></loader>
    <main v-cloak>
      <div class="container">
        <div class="row no-gutters justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <div class="top" ref="top">
              <div class="brand justify-content-between align-center">
                <div class="row no-gutters align-center">
                  <div class="brand-logo">
                    <img :src="brandLogo" class="image">
                  </div>
                  <div class="brand-name">{{ brandTitle }}</div>
                </div>
                <a target="_blank" href="https://ocard.co/">
                  <img class="w-100" src="../../../assets/img/powered-by-light-transparent.svg" alt="Powered by Ocard">
                </a>
              </div>
              <div class="trial-coupon">
                <img :src="image" class="image" ref="image">
              </div>
              <div class="tool">
                <div class="meta">
                  <div class="name">
                    <span>{{ name }}</span>
                  </div>
                  <div class="expire" v-if="valid !== null || expire !== null">
                    {{ valid | moment('l') }}～{{ expire | moment('l') }}
                  </div>
                  <div class="expire" v-else>
                    {{ $t('trialCoupon.validDays', { day: expireDay }) }}
                  </div>
                  <div class="expire" v-if="nextDayRequired">
                    {{ $t('trialCoupon.validFromTomorrow') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <div class="tabs">
                <button
                  class="tab"
                  :class="{ 'tab--active': currentTab === 'INFO' }"
                  v-on:click="currentTab = 'INFO'"
                >{{ $t('trialCoupon.details') }}</button>
                <button
                  class="tab"
                  :class="{ 'tab--active': currentTab === 'STORES' }"
                  v-on:click="currentTab = 'STORES'"
                >{{ $t('trialCoupon.branches') }}</button>
              </div>
              <template
                v-if="currentTab === 'INFO'"
              >
                <div class="sub-title">{{ $t('coupons.instruction') }}</div>
                <div class="desc" v-html="desc" v-linkified></div>
                <div class="sub-title">{{ $t('coupons.how') }}</div>
                <div class="comment" v-html="comment" v-linkified></div>
              </template>
              <template
                v-if="currentTab === 'STORES'"
              >
                <div class="store">
                  <div v-for="store in stores" :key="store.token">
                    <div class="item branch-toggle"
                      :ref="'storeToggle' + store.token" v-on:click="toggleStore(store.token)">
                      <i class="material-icons icon">store</i>
                      <div class="content">{{ store.name }}</div>
                      <i class="material-icons more">expand_more</i>
                    </div>
                    <div class="branches" :ref="'store' + store.token">
                      <div class="branch">
                        <a class="item" :href="'tel:' + store.tel">
                          <i class="material-icons icon">call</i>
                          <div class="content">{{ store.tel }}</div>
                        </a>
                        <a class="item" target="_blank" :href="'https://www.google.com/maps/?q=' + store.address">
                          <i class="material-icons icon">place</i>
                          <div class="content">{{ store.address }}</div>
                        </a>
                        <div class="item hours-toggle" :ref="'hoursToggle' + store.token" v-on:click="toggleHours(store.token)">
                          <i class="material-icons icon">query_builder</i>
                          <div class="content">{{ $t('brand.openTime') }}</div>
                          <i class="material-icons more">expand_more</i>
                        </div>
                        <div class="hours" :ref="'hours' + store.token">
                          <div class="item"  v-for="(hours, index) in store.openhour" :key="`open-hour-${store.token}-${index}`">
                            <div class="content">{{ [ hours.week === '7' ? '0' : hours.week, 'e'] | moment('ddd') }} {{ hours.time }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </main>
    <footer class="footer">
      <div class="containter">
        <div class="row justify-content-center narrow-gutters">
          <div class="col col-md-6 col-lg-4">
            <template v-if="claimed">
              <button class="btn disabled" disabled>{{ $t('trialCoupon.claimed') }}</button>
            </template>
            <template v-else>
              <button class="btn" :class="{ 'btn-loading': loading }" v-on:click="getCoupon">
                {{ $t('claim.collect') }}
                <div class="btn-loader"><span></span><span></span><span></span></div>
              </button>
              <div class="remain" v-if="total !== null">
                {{ $t('trialCoupon.totalAndRemaining', { total: total.toLocaleString(), remaining: remain.toLocaleString() }) }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </footer>
    <div class="background" ref="background">
      <div class="image" :style="`background-image: url('${image}')`"></div>
      <div class="overlay"></div>
    </div>

    <cell-input
      v-if="showCellInput"
      :title="$t('trialCoupon.claim')"
      v-on:close="showCellInput = false"
      v-on:submit="claim"
    ></cell-input>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Axios from '@/helpers/axios';
import Loader from '@/components/Loader.vue';
import linkify from 'vue-linkify';
import swal from 'sweetalert2';

import CellInput from '@/components/CellInput.vue';

export default {
  name: 'TrialCoupon',
  data() {
    return {
      brandTitle: '',
      brandLogo: '',
      image: '',
      name: '',
      valid: '',
      expire: '',
      expireDay: null,
      nextDayRequired: false,
      remain: null,
      total: null,
      desc: '',
      comment: '',
      stores: [],
      claimed: false,

      currentTab: 'INFO',
      showCellInput: false,
      loading: false,
    };
  },
  props: {
    avatar: {
      type: String,
    },
  },
  computed: {
    ...mapState(['loader', 'brand', 'user', 'coupon', 'client']),
  },
  methods: {
    ...mapMutations([
      'setLoader',
    ]),
    momentWeek(week) {
      return String(Number(week) - 1);
    },
    toggleStore(token) {
      this.$refs[`storeToggle${token}`][0].classList.toggle('expended');
      this.$refs[`store${token}`][0].classList.toggle('expended');
    },
    toggleHours(token) {
      this.$refs[`hoursToggle${token}`][0].classList.toggle('expended');
      this.$refs[`hours${token}`][0].classList.toggle('expended');
    },
    claim(cell) {
      const { token } = this.$route.params;

      this.loading = true;

      Axios({
        method: 'post',
        url: '/couponEvent/collect',
        data: {
          token,
          bearer: this.client.utk,
          cell,
          ...this.$route.query,
        },
      })
        .then((response) => {
          this.showCellInput = false;
          this.loading = false;

          if (response.data.code !== 500) {
            if (response.data.msg) {
              swal.fire({
                text: response.data.msg,
                confirmButtonText: this.$i18n.t('common.ok'),
              });
            }
            return;
          }

          swal.fire({
            text: response.data.msg,
            confirmButtonText: this.$i18n.t('common.ok'),
          }).then(() => {
            window.location.href = response.data.data.redirect_url;
          });
        });
    },
    getCoupon() {
      if (this.client.utk) {
        this.claim();
      } else {
        this.showCellInput = true;
      }
    },
  },
  beforeMount() {
    const { token } = this.$route.params;

    Axios({
      method: 'post',
      url: '/couponEvent/info',
      data: {
        token,
        ...this.$route.query,
      },
    })
      .then((response) => {
        this.brandTitle = response.data.data.brand;
        this.brandLogo = response.data.data.brand_logo;
        this.image = response.data.data.image;
        this.name = response.data.data.name;
        this.valid = response.data.data.start_time;
        this.expire = response.data.data.end_time;
        this.expireDay = response.data.data.expire_day;
        this.nextDayRequired = response.data.data.next_day_required;
        this.remain = response.data.data.remain_count;
        this.total = response.data.data.total;
        this.desc = response.data.data.desc;
        this.comment = response.data.data.comment;
        this.stores = response.data.data.stores;
        this.claimed = response.data.data.joined;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updated() {
    this.setLoader(false);
  },
  components: {
    Loader,
    CellInput,
  },
  directives: {
    linkified: linkify,
  },
};
</script>

<style lang="sass" scoped>
$cb: cubic-bezier(.4, 0, .2, 1)

.view--trial-coupon
  width: 100%
  height: 100%
  position: relative

  color: #333

.background
  position: fixed
  width: 100%
  width: 100vw
  height: 70%
  height: 70vh
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: -1

  .overlay,
  .image
    position: absolute
    top: -10px
    right: -10px
    bottom: -10px
    left: -10px

    background-color: rgba(0, 0, 0, .45)

    background-size: cover
    background-position: center

  .overlay
    -webkit-backdrop-filter: saturate(150%)

  .image
    filter: blur(10px)

.header
  position: fixed
  top: 0
  right: 0
  left: 0
  padding: 12px
  z-index: 1020

  background-color: rgba(0, 0, 0, .1)

  color: white

  .nav
    display: flex
    justify-content: space-between
    align-items: center

  .nav-brand
    display: flex
    align-items: center

    .image
      height: 32px
      width: 32px
      margin-right: 16px

      background-position: center
      background-size: cover
      border-radius: 50%

    .title
      flex-grow: 1
      margin: 3px 0

      text-shadow: 0 1px 2px rgba(0, 0, 0, .5)
      font-size: 0.875rem
      font-weight: bold
      text-align: center
      line-height: 28px

  .avatar
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .25)
    width: 28px
    height: 28px

    border: 1px solid white
    border-radius: 2px

    cursor: pointer

    &.round
      border-radius: 50%
main
  .brand
    margin: 20px auto 8px
    max-width: 90%
    display: flex
    align-items: center

    .brand-logo
      width: 28px
      height: 28px
      padding: 2px
      margin-right: 10px

      line-height: 1
      border-radius: 6px

      background-color: white

      .image
        width: 24px
        height: 24px

        border-radius: 6px

    .brand-name
      flex-grow: 1

      color: white
      font-weight: bold

      line-height: 28px

  .trial-coupon
    position: relative
    margin: 8px auto 20px
    max-width: 90%
    height: auto

    text-align: center

    .image
      width: 100%
      height: auto

  .bottom
    margin-top: 24px
    padding: 24px 16px 56px
    border-radius: 24px 24px 0 0

    background-color: white

  .tool
    color: white

  .tabs
    display: flex
    justify-content: space-between

    .tab
      width: calc((100% - 8px) / 2)
      padding: 10px 0

      background-color: #F5F5F5

      border: none
      border-radius: 12px

      color: #8D8D8D
      font-weight: bold

      appearance: none
      outline: none

      &--active
        background-color: #FFEA00

        color: #333

  .name
    margin-bottom: 5ox

    font-size: 1.125em
    font-weight: bold
    text-align: center

    .multi
      display: inline-block
      margin-left: 4px

    .material-icons
      color: rgba(255, 255, 255, .5)

      cursor: pointer
      font-size: 1rem

      transform: translateY(2px)

  .limited
    padding: 0 16px
    margin: 20px 0 10px
    font-size: 0.875rem

    .content
      padding: 8px 0
      text-align: center
      background-color: rgba(255, 255, 255, .2)
      border-radius: 4px

    .material-icons
      display: inline-block
      vertical-align: bottom
      font-size: 1.331rem
      margin-right: 6px

  .tool
    padding: 0 24px
    display: flex
    align-items: center

  .meta
    margin: 0 8px
    flex-grow: 1

  .expire
    font-size: 0.875rem
    text-align: center

    color: rgba(255, 255, 255, .5)

  .sub-title
    padding: 0 16px
    margin: 20px 0 10px

    font-weight: bold
    font-size: 0.875rem
    letter-spacing: 2px
    color: #686868
    text-transform: uppercase

  .desc,
  .comment
    margin: 8px 0 24px

    font-size: 0.875rem
    line-height: 1.6
    white-space: pre-wrap

    ::v-deep .linkified
      text-decoration: underline

  .comment
    margin-bottom: 95px

  .info
    font-size: 0.75rem
    color: rgba(255, 255, 255, .5)
    text-align: center

  .store
    padding: 20px 0
    font-size: 0.875rem

    .item
      display: flex
      align-items: center
      padding: 0 16px
      margin-bottom: 16px

      color: inherit

      &:hover
        color: currentcolor
        text-decoration: none

    .icon
      margin-right: 8px
      font-size: 1.331rem
      color: #BDBDBD

    .content
      flex-grow: 1

    .more
      margin-left: 12px
      color: #BBB

      transform-origin: center center

  .branch-toggle
    cursor: pointer

    &.expended
      & > .more
        transform: rotateX(180deg)

  .branches
    margin-left: 20px
    max-height: 0px
    overflow: hidden

    transition: max-height .25s cubic-bezier(0, 1, 0, 1)

    &.expended
      max-height: 10000px
      transition: max-height 1s ease-in-out

      & > .more
        transform: rotateX(180deg)

  .hours-toggle
    cursor: pointer

    &.expended
      & > .more
        transform: rotateX(180deg)

  .hours
    margin-left: 30px
    max-height: 0px
    overflow: hidden

    transition: max-height .25s cubic-bezier(0, 1, 0, 1)

    &.expended
      max-height: 10000px
      transition: max-height 1s ease-in-out

.footer
  position: fixed
  right: 0
  bottom: 0
  left: 0
  padding: 12px
  z-index: 1020

  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), white)

  text-align: center

  .remain
    margin-top: 4px

    font-size: 0.75rem

  .btn
    position: relative
    padding: 10px
    display: block
    width: 100%
    box-shadow: none

    border-radius: 99px

    background-color: #ffea00

    color: #333
    font-weight: bold
    font-size: 1.125em

    outline: none

    &:active
      opacity: .5

      transform: scale(.95)

    &:disabled
      opacity: 1

      background-color: #f5f5f5

      color: rgba(0, 0, 0, .25)

      cursor: not-allowed

    &.btn-loading
      pointer-events: none

      .btn-loader
        display: block

    .btn-loader
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      border-radius: 99px
      display: none

      background-color: inherit

      &.inverse
        span
          background-color: white

      span
        display: inline-block
        width: 10px
        height: 10px
        border-radius: 100%
        background-color: #575757
        margin: 18px 5px
        opacity: 0

        &:nth-child(1)
          animation: opacitychange .5s ease-in-out infinite

        &:nth-child(2)
          animation: opacitychange .5s ease-in-out .166666667s infinite

        &:nth-child(3)
          animation: opacitychange .5s ease-in-out .333333334s infinite

        @keyframes opacitychange
          0%, 100%
            opacity: 0

          60%
            opacity: 1
</style>
